import { render, staticRenderFns } from "./groessere-vdwF.vue?vue&type=template&id=f7b6f052&"
import script from "./groessere-vdwF.vue?vue&type=script&lang=js&"
export * from "./groessere-vdwF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports